import { computed } from 'vue'

interface ParsedRow {
  institution: string
  analyst: string
  email?: string
  phone?: string
}

export function useParsedAnalysts(html?: string) {
  return computed<ParsedRow[]>(() => {
    const raw = html || ''
    if (!raw) return []

    let container: HTMLElement | null = null
    if (typeof DOMParser !== 'undefined') {
      try {
        const doc = new DOMParser().parseFromString(raw, 'text/html')
        container = doc.body
      } catch {
        container = null
      }
    }

    if (!container && typeof document !== 'undefined') {
      const d = document.createElement('div')
      d.innerHTML = raw
      container = d
    }

    if (!container) return []

    const tableEl = container.querySelector('table')
    if (!tableEl) return []

    const rows = Array.from(tableEl.querySelectorAll('tr'))
    if (rows.length === 0) return []

    const dataRows = rows.slice(1)

    return dataRows.map(row => {
      const cells = Array.from(row.querySelectorAll('td'))
      const institution = (cells[0]?.textContent || '').trim()
      const analyst = (cells[1]?.textContent || '').trim()
      let email: string | undefined
      let phone: string | undefined
      const contactCell = cells[2]
      if (contactCell) {
        const a = contactCell.querySelector('a[href^="mailto:"]') as HTMLAnchorElement | null
        if (a) email = (a.getAttribute('href') || '').replace(/^mailto:/, '') || a.textContent?.trim()
        const phoneMatch = contactCell.textContent?.match(/(\+?\d[\d\s().-]{5,})/)
        if (phoneMatch) phone = phoneMatch[0].trim()
      }

      return {
        institution,
        analyst,
        email,
        phone,
      }
    })
  })
}
